import type { TableName } from '@openx/components-table/Table.tsx';
import { type AllTableCriteria, CriteriaDimension, SortDirection } from '@openx/types/tableCriteria.ts';
import { TABLE_PAGE_SIZE } from '../constants.ts';

export interface TableConfig {
  limit: number;
  offset: number;
  sort_field: string;
  sort_order: SortDirection;
}

export const getTableConfig = (
  tableName: TableName,
  criteria: Record<string, AllTableCriteria>,
  defaultSortField: string,
  defaultSortDirection: SortDirection = SortDirection.DESC
): TableConfig => {
  const sortCriteria = criteria?.[tableName]?.[CriteriaDimension.SORT];

  // For DEAL_INSIGHTS_DELIVERY_BY_AD_SIZE table, all sorting is done locally since we have only a few records
  // So sortLocally flag is used to determine if we should use default sorting for backend requests
  const sortField = sortCriteria?.isServerSortDisabled ? defaultSortField : (sortCriteria?.column ?? defaultSortField);
  const sortOrder = sortCriteria?.isServerSortDisabled
    ? defaultSortDirection
    : (sortCriteria?.direction ?? defaultSortDirection);

  return {
    limit: criteria?.[tableName]?.[CriteriaDimension.PAGINATION]?.pageSize ?? TABLE_PAGE_SIZE,
    offset:
      ((criteria?.[tableName]?.[CriteriaDimension.PAGINATION]?.pageNumber ?? 1) - 1) *
      (criteria?.[tableName]?.[CriteriaDimension.PAGINATION]?.pageSize ?? TABLE_PAGE_SIZE),
    sort_field: sortField,
    sort_order: sortOrder,
  };
};
